import { startOfDay } from 'date-fns'

const minDate = new Date(1900, 0, 1)

const maxDate = new Date(2099, 11, 21)

const getToday = () => startOfDay(new Date())

export { minDate, maxDate, getToday }
